
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './assest/iconfont/icon.css'
import './anmins.css'
import './keyframes.css'
import * as serviceWorker from './serviceWorker';
import Cookies from 'js-cookie';
import Home from '../src/page/home/index'
// Provider是react-redux两个核心工具之一，作用：将store传递到每个项目中的组件中
// 第二个工具是connect，稍后会作介绍
import { Provider } from 'react-redux'
// 引入创建好的store实例
import store from './store/index.js'
import { HashRouter as Router, Route, Link } from "react-router-dom";

import HeaderNav from './components/com_home/headerNav.js';
import { ToastContainer } from 'react-toastify';
import { navshow } from './tool/navtool';
import { startTime } from './tool/runtime';
import { renderlinkcss } from './tool/tools';
import { createBrowserHistory } from 'history';
const history = createBrowserHistory();
require('./config/ips')

const styles = {

  aa: {
    cursor: "pointer",
    display: "block",
    color: "inherit",
    textDecoration: "none",
    fontWeight: "500",
    lineHeight: "80px",
    textAlign: "center"
  },
  a: {
    display: "block",
    cursor: "pointer",
    padding: "0 2.5rem",
    color: "inherit",
    textDecoration: "none",
    fontWeight: "500",
    lineHeight: "80px",
    textAlign: "center"
  }
}


document.onclick = ((e) => {
  if (e.target.className == "mylink") {
    navshow()
  }
})

const onClick = () => {
  window.scrollTo(
    0,
    0
  );
}


const handlescroll = () => {
  var changgear = document.getElementById("changgear")
  let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;

  var topbar = document.getElementById("nprogress").querySelector(".bar");
  var docuH = document.documentElement.clientHeight;
  var allbodyH = document.documentElement.offsetHeight;


  if (docuH && allbodyH) {
    var bardata = top / (allbodyH - docuH) * 100
    top >= 0 && (topbar.style.width = "" + bardata + "%");
  }



  var mobtop = document.getElementById("totop");
  var pctop = document.getElementById("pc-top");
  if (top >= 180) {
    mobtop && (mobtop.style.display = "block")
    pctop && (pctop.style.top = "-10vh")
  } else {
    mobtop && (document.getElementById("totop").style.display = "none")
    pctop && (pctop.style.top = "-100vh")
  }

  if(top>=40){
    changgear.style.bottom="0px"
  }else{
    changgear.style.bottom="-9999px"
  }
}


var timeOutFn = false

window.addEventListener("scroll", () => {
  timeOutFn && clearTimeout(timeOutFn);

  timeOutFn = setTimeout(function () {
    //todo 
    handlescroll()
  }, 150)


})



startTime()

// renderlinkcss('https://cdn.jsdelivr.net/gh/moezx/cdn@3.7.5/css/lib.min.css')
// renderlinkcss("https://fonts.googleapis.com/css?family=Noto+SerifMerriweather|Merriweather+Sans|Source+Code+Pro|Ubuntu:400,700|Noto+Serif+SC")

ReactDOM.render(


  (
    <div>
      <ToastContainer />

      {/* 将store作为prop传入，即可使应用中的所有组件使用store */}

      <Provider store={store}>
        <Router>
          <div className="leftnav" style={{}}>
            <div className="leftnavul">

              <Link style={styles.a} className="mylink" to="/">
                首页
              </Link>

              <a style={styles.a} className="mylink" href="https://www.jianshu.com/u/e974af4433d8" target="_blanket">
                简书
              </a>

              <a style={styles.a} className="mylink" href="https://github.com/A-ANing" target="_blanket">
                Github
              </a>
              

              <Link style={styles.a} className="mylink" to="/FriendsLink">
                友链
              </Link>

              <Link style={styles.a} className="mylink" to="/Board">
                留言板
              </Link>

              <Link style={styles.a} className="mylink" to="/About">
                关于
              </Link>

              <Link style={styles.a} className="mylink" to="/writeart">
                写文章
              </Link>

            </div>
          </div>

          {/* {
          (() => {
            if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
              //alert("当前是手机端")
              return <div className="box"><Home /></div>//如果是手机打开加载手机界面
            } else { */}
          {/* //alert("当前是电脑端")
              return  */}
          <div className="box">
            <Home />
            <div className="masks"></div>
          </div>

          <div><HeaderNav history={history}/></div>
          {/* }

          })() */}

          <div class="changeSkin-gear no-select" id="changgear" style={{ visibility: "visible", bottom: "-9999px" }}>
            <div class="keys">
              <span id="open-skinMenu"><label className="change-bg">切换主题 | SCHEME TOOL &nbsp;</label><i class="iconfont icon-gear inline-block rotating"></i></span>
            </div>
          </div>

          <div class="skin-menu no-select">
            <div class="theme-controls row-container">
              <ul class="menu-list">
                <li id="bg_0" data-text="默认是纯洁的白色~">
                  <i class="fa fa-television" aria-hidden="true"></i>
                </li>
                <li id="bg_1" data-text="樱花飞舞~">
                  <i class="iconfont icon-sakura" aria-hidden="true"></i>
                </li>
                <li id="bg_2" data-text="格子控！">
                  <i class="fa fa-slack" aria-hidden="true"></i>
                </li>
                <li id="bg_3" data-text="小点点~">
                  <i class="iconfont icon-dots" aria-hidden="true"></i>
                </li>
                <li id="bg_4" data-text="充满力量的橙色">
                  <i class="fa fa-optin-monster" aria-hidden="true"></i>
                </li>
                <li id="bg_5" data-text="pixiv主题~">
                  <i class="iconfont icon-pixiv" aria-hidden="true"></i>
                </li>
                <li id="bg_6" data-text="必应图片">
                  <i class="iconfont icon-bing" aria-hidden="true"></i>
                </li>
                <li id="bg_7" data-text="关灯！">
                  <i class="fa fa-moon-o" aria-hidden="true"></i>
                </li>
              </ul>
            </div>
          </div>


          <a href="javascript:;" id="pc-top" onClick={onClick}></a>


          <div className="totop" id="totop" onClick={onClick}>
            <i className="fe fe-rocket"></i>
          </div>


          <div id="nprogress"><div className="bar" role="bar"><div className="peg"></div></div></div>
        </Router>
      </Provider>
    </div>
  ),
  document.getElementById('root')
);

global.NightColor="#31363b"

var bgConfig = {
		
  "bg_0": {
    "name": "white",
    "desc": "默认是纯洁的白色~",
    "url": "",
    "strategy": "none",
    "isNight": ""
  },
  
  "bg_1": {
    "name": "sakura",
    "desc": "樱花飞舞~",
    "url": "https://view.lixingyong.com/images/2020/07/23/695cc3a80b21ee7f18bd731824ab9638.png",
    "strategy": "none",
    "isNight": ""
  },
  
  "bg_2": {
    "name": "gribs",
    "desc": "格子控！",
    "url": "https://view.lixingyong.com/images/2020/07/23/defc1b6783cd16774900517d3b38ded7.jpg",
    "strategy": "none",
    "isNight": ""
  },
  
  "bg_3": {
    "name": "KAdots",
    "desc": "小点点~",
    "url": "https://view.lixingyong.com/images/2020/07/23/kyotoanimation.png",
    "strategy": "none",
    "isNight": ""
  },
  
  "bg_4": {
    "name": "totem",
    "desc": "充满力量的橙色",
    "url": "https://view.lixingyong.com/images/2020/07/23/little-monster.png",
    "strategy": "none",
    "isNight": ""
  },
  
  "bg_5": {
    "name": "pixiv",
    "desc": "pixiv主题~",
    "url": "https://view.lixingyong.com/images/2020/07/23/star02.png",
    "strategy": "none",
    "isNight": ""
  },
  
  "bg_6": {
    "name": "bing",
    "desc": "必应图片",
    "url": "https://api.shino.cc/bing/",
    "strategy": "cover",
    "isNight": "true"
  },
  
  "bg_7": {
    "name": "dark",
    "desc": "关灯！",
    "url": "",//https://view.lixingyong.com/images/2020/07/23/me.png
    "strategy": "cover",
    "isNight": "true"
  },
};
var themeConfig = {};



var changeBg = (tagClass, callback) => {
  var bgAttr = bgConfig[tagClass]||tagClass;
  if (!bgAttr)
      return;
  themeConfig.bgAttr = bgAttr;

  document.body.style.backgroundImage=!bgAttr["url"]? "none" : "url(" + bgAttr["url"] + ")"

  changeSkinSecter()
  //changeSkinSecter();
  if(!callback || typeof callback == "undefined" || callback == undefined){
    return false
  }else{
    callback(bgAttr["isNight"])
  }
};

if(!Cookies.get("bgconfig")){
  changeBg(bgConfig["bg_7"])
}

if(Cookies.get("bgconfig")){
  changeBg(JSON.parse(Cookies.get("bgconfig")))
}

function changeSkinSecter(){
  if (Object.getOwnPropertyNames(themeConfig).length == 0) {
    return
  }
  var bgAttr = themeConfig.bgAttr;
  if (bgAttr["isNight"]) {
    document.documentElement.classList.add("dark-mode")//"#31363b"
    document.documentElement.classList.remove("light-mode")
  }else{
    document.documentElement.classList.add("light-mode")//"#31363b"
    document.documentElement.classList.remove("dark-mode")
  }
}



Object.keys(bgConfig).forEach(function(currBg) {
  document.querySelector(".skin-menu").querySelector("#"+currBg).onclick=()=>{
    changeBg(currBg, function() {
      Cookies.set("bgconfig", bgConfig[currBg]);
      document.querySelector(".skin-menu").classList.remove("show")
      setTimeout(function() {
        document.querySelector(".changeSkin-gear").style.visibility= "visible"
      }, 300)
  })
  }
 
})







document.getElementById("changgear").onclick=()=>{
   var menu = document.querySelector(".skin-menu")
   if(Array.from(menu.classList).indexOf("show")>=0){
    document.querySelector(".skin-menu").classList.remove("show")

   }else{
    document.querySelector(".skin-menu").classList.add("show")
   }
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
